export enum AutoPlayType {
  NONE = 0, // When the current video stops playing, it will remain stopped until the user click the play button
  NEXT = 1, // When the current video stops playing, it will configure the video player to play the next available video
  LOOP = 2, // When the current video stops playing, it will configure the video player to play the same video again
}
